module.exports = __webpack_public_path__ + "img/icon-slot-white.fdbdd905.svg";